module.exports = __webpack_public_path__ + "fonts/Alata-Regular.woff!static";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Alata-Regular.woff
// module id = 44
// module chunks = 0